module.exports = "/images/etablissements.svg?3d1e384481ac3fe118b60faf33999c93";